import { useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * The first time this page stays open, remember it. Leaving the page tells the
 * API that this login has seen the NEW pills, so the next visit hides them.
 * keepalive lets a reload finish the request.
 */
export default function useAttentionSeen(surface, token) {
  useEffect(() => {
    if (!surface || !token) return undefined;
    const key = `dn-attention-open:${surface}`;
    const timer = window.setTimeout(() => {
      sessionStorage.setItem(key, "1");
    }, 0);
    return () => {
      window.clearTimeout(timer);
      if (sessionStorage.getItem(key) !== "1") return;
      sessionStorage.removeItem(key);
      fetch(`${BACKEND_URL}/api/admin/attention/seen`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ surface }),
        keepalive: true,
      }).catch(() => {});
    };
  }, [surface, token]);
}
